export const mockAPIPath = {
    UNDER_MAINTENANCE:"/under-maintenance",
};

export const serverAPIPath = {
    UNDER_MAINTENANCE:"/master/system-config"

};